"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCancelSubscriptionErrorResponse = exports.Name = exports.CancelSubscriptionFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'cancel-subscription-failed';
const CancelSubscriptionFailedEvent = exports.CancelSubscriptionFailedEvent = Name;
const isCancelSubscriptionErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isCancelSubscriptionErrorResponse = isCancelSubscriptionErrorResponse;
//# sourceMappingURL=index.js.map